import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvoiceSummaryTotal = styled.div`
  padding-top: ${Spacing.S8};
  border-top: 1px solid ${Color.Grey500};
`
